import {View} from 'MWC';
import tpl from '../templates/standalone';
import {TYPE_BRANCHES} from '../variables';
import PropTypes from 'prop-types';
import React from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            type: props.type,
            isOpen: false,
            isMobile: window.innerWidth <= 500,
            isDesktop: window.innerWidth > 500
        };

        this.dropdownRef = React.createRef();

        this.toggleType = this.toggleType.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    updateWidth = () => {
        this.setState({
            isMobile: window.innerWidth <= 500,
            isDesktop: window.innerWidth > 500
        });
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        window.addEventListener('resize', this.updateWidth);
    }

    toggleType = type => {
        this.setState({type: type, isOpen: false});
    };

    handleClickOutside = event => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({isOpen: false});
        }
    };

    toggleDropdown = () => {
        this.setState(prevState => ({isOpen: !prevState.isOpen}));
    };

    static displayName = 'ExchangeRates.Views.Standalone';

    static defaultProps = {
        type: TYPE_BRANCHES
    };

    static propTypes = {
        onClose: PropTypes.func
    };
}
